import React from 'react';
import './Home.css';
import QuickActions from './QuickActions';
import StatsOverview from './StatsOverview';
import RecentWinners from './RecentWinners';
import TrendingGiveaways from './TrendingGiveaways';
import QuickStats from './QuickStats';

function Home({ onNavigate, giveaways, stats }) {
  return (
    <div className="home-page">
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="animate-fade-in">Welcome to NitroDrop</h1>
          <p className="hero-subtitle animate-fade-in-delay">
            The Ultimate Discord Nitro & Cash Giveaway Platform
          </p>
          <div className="hero-buttons animate-slide-up">
            <button className="btn-primary" onClick={() => onNavigate('giveaways')}>
              View Giveaways
            </button>
            <button className="btn-secondary" onClick={() => onNavigate('extra-entries')}>
              Get Extra Entries
            </button>
          </div>
        </div>
      </div>

      <div className="container">
        <QuickStats stats={stats} />
      </div>

      <div className="container">
        <div className="home-grid">
          <div className="home-grid-item">
            <TrendingGiveaways giveaways={giveaways} />
          </div>
          <div className="home-grid-item">
            <RecentWinners />
          </div>
        </div>
      </div>

      <div className="container">
        <StatsOverview stats={stats} />
      </div>

      <div className="features-section">
        <div className="container">
          <h2 className="section-title">Why Choose NitroDrop?</h2>
          <div className="features-grid">
            <div className="feature-card animate-card">
              <div className="feature-icon">🎁</div>
              <h3>Multiple Giveaways</h3>
              <p>Enter tons of active giveaways for Discord Nitro, cash, and gift cards.</p>
            </div>
            <div className="feature-card animate-card" style={{ animationDelay: '0.1s' }}>
              <div className="feature-icon">⚡</div>
              <h3>Boost Your Entries</h3>
              <p>Get 2x or 4x entry multipliers with our boost system.</p>
            </div>
            <div className="feature-card animate-card" style={{ animationDelay: '0.2s' }}>
              <div className="feature-icon">🎯</div>
              <h3>Fair & Transparent</h3>
              <p>100% fair draws with complete transparency and real winners.</p>
            </div>
            <div className="feature-card animate-card" style={{ animationDelay: '0.3s' }}>
              <div className="feature-icon">💰</div>
              <h3>Big Prizes</h3>
              <p>Win Discord Nitro, PayPal cash, Steam gift cards, and more!</p>
            </div>
            <div className="feature-card animate-card" style={{ animationDelay: '0.4s' }}>
              <div className="feature-icon">🚀</div>
              <h3>Fast & Easy</h3>
              <p>Simple entry process - just sign up and start entering giveaways!</p>
            </div>
            <div className="feature-card animate-card" style={{ animationDelay: '0.5s' }}>
              <div className="feature-icon">🎨</div>
              <h3>Custom Themes</h3>
              <p>Choose from multiple color themes to personalize your experience.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-box">
              <div className="stat-number">12+</div>
              <div className="stat-label">Active Giveaways</div>
            </div>
            <div className="stat-box">
              <div className="stat-number">0</div>
              <div className="stat-label">Total Participants</div>
            </div>
            <div className="stat-box">
              <div className="stat-number">100%</div>
              <div className="stat-label">Fair & Transparent</div>
            </div>
            <div className="stat-box">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Support Available</div>
            </div>
          </div>
        </div>
      </div>

      <div className="quick-actions-wrapper">
        <div className="container">
          <QuickActions onNavigate={onNavigate} />
        </div>
      </div>

      <div className="cta-section">
        <div className="container">
          <h2>Ready to Win?</h2>
          <p>Join thousands of users and start entering giveaways today!</p>
          <div className="cta-buttons">
            <button className="btn-primary large" onClick={() => onNavigate('giveaways')}>
              Browse Giveaways
            </button>
            <a 
              href="https://discord.gg/RXVZZWzMcq" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-secondary large"
            >
              Join Discord
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;

